import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { WellnessNotificationService, WellnessNotification } from 'src/app/services/wellness/wellness-notification.service';

@Component({
  selector: 'app-wellness-notifications',
  templateUrl: './wellness-notifications.component.html',
  styleUrls: ['./wellness-notifications.component.scss']
})
export class WellnessNotificationsComponent implements OnInit, OnDestroy {
  public wellnessNotifications: WellnessNotification[] = [];
  public unreadCount = 0;
  public showNotifications = false;
  public hoveredNotificationId: number | null = null;
  public tooltipTop = 0;
  public tooltipLeft = 0;
  public selectedNotification: WellnessNotification | null = null;

  private destroyed$ = new Subject<void>();

  constructor(
    private wellnessNotificationService: WellnessNotificationService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.wellnessNotificationService.getNotifications()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(notifications => {
        this.wellnessNotifications = notifications;
      });

    this.wellnessNotificationService.getUnreadCount()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(count => {
        this.unreadCount = count;
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onNotificationHover(event: MouseEvent, notificationId: number): void {
    const target = event.currentTarget as HTMLElement;
    const rect = target.getBoundingClientRect();
    this.tooltipTop = rect.top + (rect.height / 2);
    this.tooltipLeft = rect.left - 12;
    this.hoveredNotificationId = notificationId;
  }

  toggleNotifications(event: Event): void {
    event.stopPropagation();
    this.showNotifications = !this.showNotifications;
    this.hoveredNotificationId = null;
  }

  onNotificationClick(notification: WellnessNotification): void {
    this.wellnessNotificationService.markAsRead(notification.id);
    this.selectedNotification = notification;
    this.showNotifications = false;
    this.hoveredNotificationId = null;
  }

  closeNotificationPopup(): void {
    this.selectedNotification = null;
  }

  goToStudentProfile(): void {
    if (this.selectedNotification) {
      console.log('triggering goToStudentProfile with notification', this.selectedNotification);
      const roomId = this.selectedNotification.roomId;
      const studentId = this.selectedNotification.studentId;
      this.router.navigate(
        ['dashboard', 'institution', 'classes', 'list', roomId, 'users'],
        { queryParams: { studentId } }
      );
    }
    this.closeNotificationPopup();
  }

  formatNotificationDate(date: Date): string {
    const day = date.getDate();
    const months = [
      'de enero', 'de febrero', 'de marzo', 'de abril', 'de mayo', 'de junio',
      'de julio', 'de agosto', 'de septiembre', 'de octubre', 'de noviembre', 'de diciembre'
    ];
    return `${day} ${months[date.getMonth()]}`;
  }
}
